var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', {
    attrs: {
      "value": _vm.KATA.value
    }
  }, [_c('div', {
    staticClass: "page-section-wrap"
  }, [_c('section', {
    staticClass: "page-section"
  }, [_c('v-divider', {
    staticClass: "primary"
  }), _c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "h-100 px-10 py-20 py-md-30"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('div', {
    staticClass: "w-140px w-md-100 ma-auto"
  }, [_c('v-img', {
    attrs: {
      "contain": "",
      "width": "180",
      "max-height": "180",
      "src": "/images/sub/private/private-strength-icon.png"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('div', {
    staticClass: "pt-16 pl-md-20"
  }, [_c('h5', {
    staticClass: "tit tit--xs line-height-14"
  }, [_vm._v("빠른 소싱(Sourcing)")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('div', {
    staticClass: "pt-16 pl-md-60"
  }, [_c('div', [_c('ul', {
    staticClass: "dot-list dot-list--large"
  }, [_c('li', [_vm._v("고객님이 원하시는 작품을 빠르게 찾아 드리기 위해 항상 최선을 다합니다.")]), _c('li', [_vm._v("캐터옥션은 해외 미술품 수입에 대한 최고의 노하우를 보유하고 있습니다.")]), _c('li', [_vm._v("해외 블루 칩 작가 및 Hot Emerging Artist 작품을 신속 정확하게 직구 합니다.")])])]), _c('div', {
    staticClass: "mt-14 mt-md-20"
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("※ 작품의 독특함과 희소성, 가격변동에 따라 직구 및 거래 시점이 변동될 수 있습니다.")])])])])], 1)], 1), _c('v-divider', {
    staticClass: "grey-cb"
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "h-100 px-10 py-20 py-md-30"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('div', {
    staticClass: "w-140px w-md-100 ma-auto"
  }, [_c('v-img', {
    attrs: {
      "contain": "",
      "width": "180",
      "max-height": "180",
      "src": "/images/sub/private/private-strength-icon2.png"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('div', {
    staticClass: "pt-16 pl-md-20"
  }, [_c('h5', {
    staticClass: "tit tit--xs line-height-14"
  }, [_vm._v("높은 보안성, 기밀성")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('div', {
    staticClass: "pt-16 pl-md-60"
  }, [_c('div', [_c('ul', {
    staticClass: "dot-list dot-list--large"
  }, [_c('li', [_vm._v("우리는 최고의 기밀을 유지하면서, 고객에게 가장 유익한 결과가 달성될 수 있도록 노력합니다.")]), _c('li', [_vm._v("고객의 신원 및 개인판매 문의는 엄격하게 기밀로 유지됩니다.")]), _c('li', [_vm._v("고객이 명시적인 공개를 원하는 경우가 아니면 고객의 신원을 절대 공개하지 않습니다.")])])]), _c('div', {
    staticClass: "mt-14 mt-md-20"
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("※ 캐터옥션 홈페이지에 작품을 업로드 하는 것이 부담스러울 경우, 내리고 진행할 수도 있습니다.")])])])])], 1)], 1), _c('v-divider', {
    staticClass: "grey-cb"
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "h-100 px-10 py-20 py-md-30"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('div', {
    staticClass: "w-140px w-md-100 ma-auto"
  }, [_c('v-img', {
    attrs: {
      "contain": "",
      "width": "180",
      "max-height": "180",
      "src": "/images/sub/private/private-strength-icon3.png"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('div', {
    staticClass: "pt-16 pl-md-20"
  }, [_c('h5', {
    staticClass: "tit tit--xs line-height-14"
  }, [_vm._v("광범위한 네트워크 및 마케팅 전개")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('div', {
    staticClass: "pt-16 pl-md-60"
  }, [_c('div', [_c('ul', {
    staticClass: "dot-list dot-list--large"
  }, [_c('li', [_vm._v("프라이빗 세일에 적합한 구매자와 판매자를 상호 매칭하기 위하여, 캐터옥션에서는 광범위한 국내 및 국제 네트워크를 최대한 활용합니다.")]), _c('li', [_vm._v("신중하며 고도로 맞춤화된 네트워크는 고객께서 필요로 하시는 최고의 작품을 판매 또는 구입하는데 도움을 드립니다.")]), _c('li', [_vm._v("캐터옥션은 SNS, 온라인 광고, 유튜브 방송 등을 다양한 마케팅을 전개합니다.")])])])])])], 1)], 1), _c('v-divider', {
    staticClass: "grey-cb"
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "h-100 px-10 py-20 py-md-30"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('div', {
    staticClass: "w-140px w-md-100 ma-auto"
  }, [_c('v-img', {
    attrs: {
      "contain": "",
      "width": "180",
      "max-height": "180",
      "src": "/images/sub/private/private-strength-icon4.png"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('div', {
    staticClass: "pt-16 pl-md-20"
  }, [_c('h5', {
    staticClass: "tit tit--xs line-height-14"
  }, [_vm._v("1:1 맞춤 서비스")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('div', {
    staticClass: "pt-16 pl-md-60"
  }, [_c('div', [_c('ul', {
    staticClass: "dot-list dot-list--large"
  }, [_c('li', [_vm._v("다년간의 아트 비즈니스 경험을 바탕으로, 위탁자 및 구매자에게 1:1 맞춤 서비스를 제공합니다.")]), _c('li', [_vm._v("당사는 고객의 특정 요구 사항에 가장 유익한 맞춤형 구매/판매 전략을 활용합니다.")])])])])])], 1)], 1), _c('v-divider', {
    staticClass: "grey-cb"
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "h-100 px-10 py-20 py-md-30"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('div', {
    staticClass: "w-140px w-md-100 ma-auto"
  }, [_c('v-img', {
    attrs: {
      "contain": "",
      "width": "180",
      "max-height": "180",
      "src": "/images/sub/private/private-strength-icon5.png"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('div', {
    staticClass: "pt-16 pl-md-20"
  }, [_c('h5', {
    staticClass: "tit tit--xs line-height-14"
  }, [_vm._v("최저가 수수료 : 5%")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('div', {
    staticClass: "pt-16 pl-md-60"
  }, [_c('div', [_c('ul', {
    staticClass: "dot-list dot-list--large"
  }, [_c('li', [_vm._v("프라이빗 세일에서 판매된 작품의 수수료는, 일반경매작품과 동일하게 적용합니다.")]), _c('li', [_vm._v("다만, 해외에서 구입하는 작품의 수수료는 8% (실비 제외)를 적용합니다.")])])]), _c('div', {
    staticClass: "mt-14 mt-md-20"
  }, [_c('p', {
    staticClass: "page-text"
  }, [_vm._v("※ 판매수수료에 대한 자세한 내용은 다음을 참조하시기 바랍니다.")])]), _c('div', {
    staticClass: "mt-4"
  }, [_c('v-btn', {
    staticClass: "pa-0 v-btn--none-active-bg",
    attrs: {
      "small": "",
      "text": "",
      "height": "auto",
      "color": "grey-68",
      "to": "/"
    }
  }, [_c('strong', [_vm._v("자세히보기")]), _c('v-icon', [_vm._v("mdi-menu-right")])], 1)], 1)])])], 1)], 1), _c('v-divider', {
    staticClass: "grey-cb"
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "h-100 px-10 py-20 py-md-30"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('div', {
    staticClass: "w-140px w-md-100 ma-auto"
  }, [_c('v-img', {
    attrs: {
      "contain": "",
      "width": "180",
      "max-height": "180",
      "src": "/images/sub/private/private-strength-icon6.png"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('div', {
    staticClass: "pt-16 pl-md-20"
  }, [_c('h5', {
    staticClass: "tit tit--xs line-height-14"
  }, [_vm._v("기관 소장품의 "), _c('br', {
    staticClass: "d-none d-md-block"
  }), _vm._v("빠른 판매")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('div', {
    staticClass: "pt-16 pl-md-60"
  }, [_c('div', [_c('ul', {
    staticClass: "dot-list dot-list--large"
  }, [_c('li', [_vm._v("기업, 은행, 협단체, 미술관, 박물관 등 기관/단체 소장품에 대하여 신속한 판매전략을 활용합니다.")]), _c('li', [_vm._v("기관 소장품은 실사 → 상태검사 → 가격산정 → 활용/판매 방안을 포함한 별도의 <작품매각 프로그램>하에 판매를 진행합니다.")])])])])])], 1)], 1), _c('v-divider', {
    staticClass: "grey-cb"
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "6",
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "h-100 px-10 py-20 py-md-30"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('div', {
    staticClass: "w-140px w-md-100 ma-auto"
  }, [_c('v-img', {
    attrs: {
      "contain": "",
      "width": "180",
      "max-height": "180",
      "src": "/images/sub/private/private-strength-icon7.png"
    }
  })], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "2"
    }
  }, [_c('div', {
    staticClass: "pt-16 pl-md-20"
  }, [_c('h5', {
    staticClass: "tit tit--xs line-height-14"
  }, [_vm._v("작품의 잠재가치 발굴 및 부가가치 제고")])])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('div', {
    staticClass: "pt-16 pl-md-60"
  }, [_c('div', [_c('ul', {
    staticClass: "dot-list dot-list--large"
  }, [_c('li', [_vm._v("의뢰받은 작품에 대한 미술사적 분석을 실시한 후에 <작품설명서>를 발행합니다.")]), _c('li', [_vm._v("정밀한 상태검사 및 이력 조사를 실시한 후에 <상태검사서> 및 <작품이력서>를 발행합니다.")]), _c('li', [_vm._v("캐터옥션의 프라이빗 세일에 출품되었음을 확인하는 <출품확인서>를 발행합니다.")]), _c('li', [_vm._v("의뢰인에게 받은 <진품보증서>를 구매인에게 전달하여, 작품의 진품성을 확보합니다.")])])])])])], 1)], 1), _c('v-divider', {
    staticClass: "grey-cb"
  })], 1)], 1)], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }